export const KYC_IDV_DOCS_SUBMITTED_EVENTS = {
  VIEW_KYC_IN_REVIEW_IDV_DOCS_SUBMITTED_PAGE:
    'view_kyc_in_review_idv_docs_submitted',
} as const;
